module.exports = __webpack_public_path__ + "img/business-consulting-light.72dc580e.png";